(function () {
  'use strict';
  var popup = document.querySelector('[data-tah-welcome]');
  if (!popup || typeof popup.showModal !== 'function') return;
  if (document.body.dataset.customerAuthenticated === 'true') return;
  if (window.Shopify && window.Shopify.designMode) return;
  var key = 'tah-welcome-dismissed-v1';
  var dismissedInPage = false;
  var timer;

  function dismissed() {
    if (dismissedInPage) return true;
    try { return sessionStorage.getItem(key) === '1'; } catch (_) { return false; }
  }

  function rememberDismissal() {
    dismissedInPage = true;
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
  }

  function closePopup() {
    if (popup.open) popup.close();
  }

  popup.addEventListener('close', function () {
    rememberDismissal();
    document.documentElement.classList.remove('tah-welcome-open');
  });
  popup.addEventListener('click', function (event) {
    if (event.target !== popup) return;
    var bounds = popup.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right
      || event.clientY < bounds.top || event.clientY > bounds.bottom) closePopup();
  });
  popup.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', rememberDismissal);
  });

  function showPopup() {
    if (dismissed() || popup.open || document.visibilityState === 'hidden' || document.body.dataset.customerAuthenticated === 'true') return;
    // Avoid competing with an account/token dialog already opened by the visitor.
    if (document.querySelector('#tokenly-modal-root .modal, dialog[open]')) return;
    popup.showModal();
    document.documentElement.classList.add('tah-welcome-open');
  }

  Promise.resolve(window.TAHAuth?.ready).then(function () { timer = window.setTimeout(showPopup, 450); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') showPopup();
  });
  window.addEventListener('pagehide', function () {
    window.clearTimeout(timer);
    closePopup();
  });
})();
